import { render, staticRenderFns } from "./editprotocol.vue?vue&type=template&id=187f3c6c&scoped=true&"
import script from "./editprotocol.vue?vue&type=script&lang=ts&"
export * from "./editprotocol.vue?vue&type=script&lang=ts&"
import style0 from "./editprotocol.vue?vue&type=style&index=0&id=187f3c6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187f3c6c",
  null
  
)

export default component.exports